import strings from 'lang/lang';
import { ReactComponent as ArrowRight } from 'styles/icon/arrowRight.svg';

function ProductsLinks() {
  return (
    <ul>
      <li>
        <a href="https://staq.io/products/payments" target="_blank"><span>{strings.footerList.text.payments}</span><ArrowRight /></a>
      </li>
      <li>
        <a href="https://staq.io/products/cards" target="_blank"><span>{strings.footerList.text.cards}</span><ArrowRight /></a>
      </li>
      <li>
        <a href="https://staq.io/products/accounts" target="_blank"><span>{strings.footerList.text.accounts}</span><ArrowRight /></a>
      </li>
      <li>
        <a href="https://staq.io/products/identity" target="_blank"><span>{strings.footerList.text.identity}</span><ArrowRight /></a>
      </li>
      <li>
        <a href="https://staq.io/products/lending" target="_blank"><span>{strings.footerList.text.productsLending}</span><ArrowRight /></a>
      </li>
      <li>
        <a href="https://staq.io/products/document-authentication" target="_blank"><span>{strings.footerList.text.authentication}</span><ArrowRight /></a>
      </li>
    </ul>
  );
}

export default ProductsLinks;